import { tienePermiso } from '../../../utils/permisosUtil';

export const permisosParametrizacionEmpresaMixin = {
  computed: {
    permisosParametrizacionEmpresa() {
      return {
        accesoModulo: tienePermiso('empresa'),
        verEmpresa: tienePermiso('readEmpresa'),
        crearEmpresa: tienePermiso('createEmpresa'),
        actualizarEmpresa: tienePermiso('updateEmpresa'),
      };
    },
  },
};
